import BaseDialog from "@/components/BaseDialog";
// 工单管理- 批量下载
export function downLoadModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./downLoadModal.vue'),
        options: {
            width: '600px',
            title: '批量下载',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
